module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/w-class.a2b64695.png";